import { currency_formatter } from "../../../../../util/currency_formatter";
import Label from "../../../../../components/label";

const Pricing = ({ rateType, ratePrice, ratePriceComment }) => {
    return (
        <div className="freelancerModalComponentWrap">
            <Label
                label="Pricing"
                className="font18Black boldFont sectionTitleWrapper"
            />

            <div className="rateWrapper">
                <div className="d-flex align-items-center mr-4">
                    <div className="font16Black boldFont">Rate Type:</div>
                    <div className="font16Black ml-1">{rateType}</div>
                </div>

                <div className="d-flex align-items-center">
                    <div className="font16Black boldFont">Proposal Amount:</div>
                    <div className="font16Black ml-1">
                        {isNaN(ratePrice)
                            ? ratePrice
                            : currency_formatter(ratePrice)}
                    </div>
                </div>
            </div>

            {ratePriceComment?.length > 0 && (
                <>
                    <div className="font16Black boldFont mt-3">
                        Rate Comments:
                    </div>
                    <div className="font14Grey" style={{ whiteSpace: 'pre-line' }}>{ratePriceComment}</div>
                </>
            )}
        </div>
    );
};

export default Pricing;
